import { render, staticRenderFns } from "./PlanInfo.vue?vue&type=template&id=4a67b3ee&scoped=true"
import script from "./PlanInfo.vue?vue&type=script&lang=js"
export * from "./PlanInfo.vue?vue&type=script&lang=js"
import style0 from "./PlanInfo.vue?vue&type=style&index=0&id=4a67b3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a67b3ee",
  null
  
)

export default component.exports